/* unplugin-vue-components disabled */import { render } from "./MdConfirm.vue?vue&type=template&id=35fcfcd8&scoped=true"
import script from "./MdConfirm.vue?vue&type=script&lang=js"
export * from "./MdConfirm.vue?vue&type=script&lang=js"

import "./MdConfirm.vue?vue&type=style&index=0&id=35fcfcd8&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fcfcd8"]])

export default __exports__